import { ActionMenu, Button, icons } from '@portal/components'
import React, { useState } from 'react'

import { useDQLEditorContext } from '../dqlEditor/context'
import { DataImportDialog } from './DataImportDialog'
import { ImportMethod } from './types'

const { CloudUpload } = icons

type DataImportMenuProps = {
  title?: string
  containerClass?: string
  buttonClass?: string
  hideIcon?: boolean
}

export default function DataImportMenu({
  title = 'Import',
  containerClass,
  buttonClass,
  hideIcon = false,
}: DataImportMenuProps) {
  const { isLoadingCollections } = useDQLEditorContext()

  const [isOpen, setIsOpen] = useState(false)
  const [importMethod, setImportMethod] = useState<ImportMethod>()

  const handleMethodSelection = (method: ImportMethod) => {
    setImportMethod(method)
    setIsOpen(true)
  }

  const handleDialogClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      <DataImportDialog
        isOpen={isOpen}
        importMethod={importMethod}
        onClose={handleDialogClose}
      />

      <div className={containerClass}>
        <ActionMenu
          items={[
            {
              label: 'Import by File',
              onClick: () => handleMethodSelection('file'),
            },
            {
              label: 'Import by JSON',
              onClick: () => handleMethodSelection('json'),
            },
          ]}
          trigger={
            <Button
              variant="default"
              disabled={isLoadingCollections}
              className={buttonClass}
            >
              {!hideIcon && <CloudUpload size={16} className="mr-2" />}
              {title}
            </Button>
          }
          align="end"
        />
      </div>
    </>
  )
}
